// Форма входа живёт прямо на странице /id для гостя (AuthRequired), попапа нет.
// С главной просто прокручиваем к форме, с остальных страниц ведём на /id.
export default function goToLogin(router, route) {
  if (route.path === '/id' || route.path.startsWith('/id/')) {
    document.getElementById('login')?.scrollIntoView({ behavior: 'smooth', block: 'start' })
    return
  }
  router.push('/id')
}
